import { Stack, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";

// Tickets with no email never get one: said in both dialogs.
const withoutEmailLine = (withoutEmail) =>
  !withoutEmail
    ? null
    : withoutEmail === 1
      ? "1 ticket has no email and will not get one: share its code or link."
      : `${withoutEmail} tickets have no email and will not get one: share their code or link.`;

/**
 * Confirm "Send ticket emails", then send. `pending` is how many tickets have
 * not had the ticket email yet; each gets its own code and link once.
 * `withoutEmail` is how many have no email to send to.
 */
export const confirmSendTicketEmails = ({
  pending,
  withoutEmail = 0,
  send,
}) => {
  const noEmail = withoutEmailLine(withoutEmail);
  if (!pending) {
    modals.open({
      title: "Send ticket emails",
      children: (
        <Stack gap="xs">
          <Text size="sm">
            Every ticket with an email has had its email. New tickets get theirs
            the next time you send.
          </Text>
          {noEmail && <Text size="sm">{noEmail}</Text>}
        </Stack>
      ),
    });
    return;
  }

  modals.openConfirmModal({
    title: "Send ticket emails",
    children: (
      <Stack gap="xs">
        <Text size="sm">
          {pending === 1
            ? "1 ticket has not had its email yet."
            : `${pending} tickets have not had their email yet.`}{" "}
          Each gets its own code and a link that opens it.
        </Text>
        {noEmail && <Text size="sm">{noEmail}</Text>}
        <Text size="xs" c="dimmed">
          Each ticket shows when its email went out.
        </Text>
      </Stack>
    ),
    labels: {
      confirm: pending === 1 ? "Send 1 email" : `Send ${pending} emails`,
      cancel: "Cancel",
    },
    onConfirm: () =>
      // An empty JSON body: Fastify refuses a JSON request without one.
      send(
        {},
        {
          onSuccess: ({ sent, failed }) =>
            notifications.show({
              title:
                sent === 1
                  ? "1 ticket email sent"
                  : `${sent} ticket emails sent`,
              message: failed
                ? `${failed} could not be sent. Try again later.`
                : undefined,
              color: failed ? "yellow" : "green",
            }),
        }
      ),
  });
};
